import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';

import {ApiModule} from '../../api/api.module';
import {PipesModule} from '../../pipes/pipes.module';
import {PlatformModule} from '../platform/platform.module';
import {SelectModule} from '../select/select.module';

import {TreeSelectNodeComponent} from './tree-select-node/tree-select-node.component';
import {TreeSelectComponent} from './tree-select.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlatformModule,
    TranslateModule,
    PipesModule,
    ApiModule,
    SelectModule
  ],
  declarations: [
    TreeSelectComponent,
    TreeSelectNodeComponent
  ],
  exports: [
    TreeSelectComponent,
    TreeSelectNodeComponent
  ],
  providers: []
})
export class TreeSelectModule {
}
